import { avLogMessagesApi } from '@availity/api-axios';
import { AvSplunkAnalytics } from '@availity/analytics-core';
import assign from 'lodash/assign';

const splunkAnalytics = new AvSplunkAnalytics(avLogMessagesApi, true);

export default (from, goTo, apiEvent) => {
  const event = {
    app: 'availity-fr-ui',
    action: 'api-request',
  };

  if (from) {
    assign(event, { 'url-source': from });
  }
  if (goTo) {
    assign(event, { 'url-goto': goTo });
  }

  splunkAnalytics.trackEvent({ ...apiEvent, ...event });
};
